'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.build_v4_url = exports.build_v3_url = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var joinParams = function joinParams(list, paramKey) {
  return list.map(function (li) {
    return li[paramKey];
  }).filter(function (v) {
    return v;
  }).join('|');
};
var getParams = function getParams(shop) {
  return (0, _keys2.default)(shop);
};

// Backward compatible routes for GCP's react route v3
var build_v3_url = exports.build_v3_url = function build_v3_url(markets) {
  return markets.map(function (market) {
    var params = getParams(market);
    return '/' + params.map(function (param) {
      return market[param] || ':' + param;
    }).join('/');
  });
};

var build_v4_url = exports.build_v4_url = function build_v4_url(markets) {
  var params = getParams(markets[0]);
  return '/' + params.map(function (param) {
    var values = joinParams(markets, param);
    var regex = values ? '(' + values + ')' : '';
    return ':' + param + regex;
  }).join('/');
};